import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

const NEAR_CAP_THRESHOLD = 0.9;

function PlanUsageBanner() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { status } = useSubscription();

  const msgCap = status?.planLimits?.msgCap;
  const msgUsed = status?.planLimits?.msgUsed;

  // No cap data yet, or unlimited plan (msgCap null = Enterprise) — nothing to warn about.
  if (msgCap == null || msgUsed == null) {
    return null;
  }

  const overCap = msgUsed >= msgCap;
  const nearCap = !overCap && msgUsed >= msgCap * NEAR_CAP_THRESHOLD;
  if (!overCap && !nearCap) {
    return null;
  }

  const variantClasses = overCap
    ? 'border-red-200 bg-red-50 text-red-700'
    : 'border-amber-200 bg-amber-50 text-amber-800';

  const message = overCap
    ? t('planUsageBanner.overCap')
    : t('planUsageBanner.nearCap', { used: msgUsed, cap: msgCap });

  return (
    <div
      className={`mx-6 mt-6 rounded-xl border p-4 flex items-center justify-between gap-4 flex-wrap ${variantClasses}`}
    >
      <p className="text-sm">{message}</p>
      <button
        type="button"
        onClick={() => navigate('/settings/billing')}
        className="inline-flex items-center rounded-lg bg-gradient-to-r from-orange-500 to-amber-600 px-4 py-2 text-sm font-semibold text-white shadow-md shadow-orange-200 transition hover:from-orange-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2"
      >
        {t('planUsageBanner.upgrade')}
      </button>
    </div>
  );
}

export default PlanUsageBanner;
